import {
  Companion_instance1y2fclwwulp17 as Companion_instance,
  Memory2d9txv6h117z7 as Memory,
} from './HealthStatus.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareMemoryFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Memory_max_getInstance(), Memory_total_getInstance(), Memory_free_getInstance(), Memory_systemAllocated_getInstance(), Memory_usage_getInstance()];
  var tmp = Companion_instance.m2a();
  properties(tmp, (it) => props);
}
function Memory_max$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(0);
}
function Memory_max$_get_name_$ref_g6cf6b() {
  return (p0) => p0.k20();
}
function Memory_max$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Memory_max$_get_serializer_$ref_nauwqu() {
  return (p0) => p0.j2j();
}
function Memory_max$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(0);
}
function Memory_max$_get_annotations_$ref_427f5u() {
  return (p0) => p0.bz();
}
var Memory_maxClass;
function Memory_max() {
  if (Memory_maxClass === VOID) {
    class $ {
      constructor() {
        Memory_max_instance = this;
        var tmp = this;
        tmp.m3f_1 = lazy(Memory_max$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n3f_1 = lazy(Memory_max$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o3f_1 = lazy(Memory_max$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Memory_max$_get_name_$ref_g6cf6b(), null);
        return tmp0.f2();
      }
      p3f(receiver) {
        return receiver.q3f_1;
      }
      m2j(receiver) {
        return this.p3f(receiver instanceof Memory() ? receiver : THROW_CCE());
      }
      v3f(receiver, value) {
        return receiver.w3f(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Memory() ? receiver : THROW_CCE();
        return this.v3f(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Memory_max$_get_serializer_$ref_nauwqu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Memory_max$_get_annotations_$ref_427f5u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Memory_max', VOID, VOID, [SerializableProperty()]);
    Memory_maxClass = $;
  }
  return Memory_maxClass;
}
var Memory_max_instance;
function Memory_max_getInstance() {
  if (Memory_max_instance === VOID)
    new (Memory_max())();
  return Memory_max_instance;
}
function Memory_total$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(1);
}
function Memory_total$_get_name_$ref_nzs99() {
  return (p0) => p0.k20();
}
function Memory_total$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Memory_total$_get_serializer_$ref_mr4mhy() {
  return (p0) => p0.j2j();
}
function Memory_total$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(1);
}
function Memory_total$_get_annotations_$ref_l1u8te() {
  return (p0) => p0.bz();
}
var Memory_totalClass;
function Memory_total() {
  if (Memory_totalClass === VOID) {
    class $ {
      constructor() {
        Memory_total_instance = this;
        var tmp = this;
        tmp.x3f_1 = lazy(Memory_total$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y3f_1 = lazy(Memory_total$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z3f_1 = lazy(Memory_total$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Memory_total$_get_name_$ref_nzs99(), null);
        return tmp0.f2();
      }
      p3f(receiver) {
        return receiver.r3f_1;
      }
      m2j(receiver) {
        return this.p3f(receiver instanceof Memory() ? receiver : THROW_CCE());
      }
      v3f(receiver, value) {
        return receiver.w3f(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Memory() ? receiver : THROW_CCE();
        return this.v3f(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Memory_total$_get_serializer_$ref_mr4mhy(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Memory_total$_get_annotations_$ref_l1u8te(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Memory_total', VOID, VOID, [SerializableProperty()]);
    Memory_totalClass = $;
  }
  return Memory_totalClass;
}
var Memory_total_instance;
function Memory_total_getInstance() {
  if (Memory_total_instance === VOID)
    new (Memory_total())();
  return Memory_total_instance;
}
function Memory_free$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(2);
}
function Memory_free$_get_name_$ref_vpwkbb() {
  return (p0) => p0.k20();
}
function Memory_free$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Memory_free$_get_serializer_$ref_yx9hvi() {
  return (p0) => p0.j2j();
}
function Memory_free$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(2);
}
function Memory_free$_get_annotations_$ref_xa6n0e() {
  return (p0) => p0.bz();
}
var Memory_freeClass;
function Memory_free() {
  if (Memory_freeClass === VOID) {
    class $ {
      constructor() {
        Memory_free_instance = this;
        var tmp = this;
        tmp.a3g_1 = lazy(Memory_free$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b3g_1 = lazy(Memory_free$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c3g_1 = lazy(Memory_free$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Memory_free$_get_name_$ref_vpwkbb(), null);
        return tmp0.f2();
      }
      p3f(receiver) {
        return receiver.s3f_1;
      }
      m2j(receiver) {
        return this.p3f(receiver instanceof Memory() ? receiver : THROW_CCE());
      }
      v3f(receiver, value) {
        return receiver.w3f(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Memory() ? receiver : THROW_CCE();
        return this.v3f(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Memory_free$_get_serializer_$ref_yx9hvi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Memory_free$_get_annotations_$ref_xa6n0e(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Memory_free', VOID, VOID, [SerializableProperty()]);
    Memory_freeClass = $;
  }
  return Memory_freeClass;
}
var Memory_free_instance;
function Memory_free_getInstance() {
  if (Memory_free_instance === VOID)
    new (Memory_free())();
  return Memory_free_instance;
}
function Memory_systemAllocated$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(3);
}
function Memory_systemAllocated$_get_name_$ref_z7s11j() {
  return (p0) => p0.k20();
}
function Memory_systemAllocated$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Memory_systemAllocated$_get_serializer_$ref_1ru04u() {
  return (p0) => p0.j2j();
}
function Memory_systemAllocated$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(3);
}
function Memory_systemAllocated$_get_annotations_$ref_1f4pa() {
  return (p0) => p0.bz();
}
var Memory_systemAllocatedClass;
function Memory_systemAllocated() {
  if (Memory_systemAllocatedClass === VOID) {
    class $ {
      constructor() {
        Memory_systemAllocated_instance = this;
        var tmp = this;
        tmp.d3g_1 = lazy(Memory_systemAllocated$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e3g_1 = lazy(Memory_systemAllocated$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f3g_1 = lazy(Memory_systemAllocated$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Memory_systemAllocated$_get_name_$ref_z7s11j(), null);
        return tmp0.f2();
      }
      p3f(receiver) {
        return receiver.t3f_1;
      }
      m2j(receiver) {
        return this.p3f(receiver instanceof Memory() ? receiver : THROW_CCE());
      }
      v3f(receiver, value) {
        return receiver.w3f(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Memory() ? receiver : THROW_CCE();
        return this.v3f(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Memory_systemAllocated$_get_serializer_$ref_1ru04u(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Memory_systemAllocated$_get_annotations_$ref_1f4pa(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Memory_systemAllocated', VOID, VOID, [SerializableProperty()]);
    Memory_systemAllocatedClass = $;
  }
  return Memory_systemAllocatedClass;
}
var Memory_systemAllocated_instance;
function Memory_systemAllocated_getInstance() {
  if (Memory_systemAllocated_instance === VOID)
    new (Memory_systemAllocated())();
  return Memory_systemAllocated_instance;
}
function Memory_usage$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(4);
}
function Memory_usage$_get_name_$ref_ijv5jk() {
  return (p0) => p0.k20();
}
function Memory_usage$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Memory_usage$_get_serializer_$ref_hrabmf() {
  return (p0) => p0.j2j();
}
function Memory_usage$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(4);
}
function Memory_usage$_get_annotations_$ref_1nbczf() {
  return (p0) => p0.bz();
}
var Memory_usageClass;
function Memory_usage() {
  if (Memory_usageClass === VOID) {
    class $ {
      constructor() {
        Memory_usage_instance = this;
        var tmp = this;
        tmp.g3g_1 = lazy(Memory_usage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h3g_1 = lazy(Memory_usage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i3g_1 = lazy(Memory_usage$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.g3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Memory_usage$_get_name_$ref_ijv5jk(), null);
        return tmp0.f2();
      }
      p3f(receiver) {
        return receiver.u3f_1;
      }
      m2j(receiver) {
        return this.p3f(receiver instanceof Memory() ? receiver : THROW_CCE());
      }
      j3g(receiver, value) {
        return receiver.w3f(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Memory() ? receiver : THROW_CCE();
        return this.j3g(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Memory_usage$_get_serializer_$ref_hrabmf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Memory_usage$_get_annotations_$ref_1nbczf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Memory_usage', VOID, VOID, [SerializableProperty()]);
    Memory_usageClass = $;
  }
  return Memory_usageClass;
}
var Memory_usage_instance;
function Memory_usage_getInstance() {
  if (Memory_usage_instance === VOID)
    new (Memory_usage())();
  return Memory_usage_instance;
}
//region block: exports
export {
  prepareMemoryFields as prepareMemoryFieldsdeb4svr86fio,
};
//endregion

//# sourceMappingURL=MemoryFields.mjs.map
